import { george, React, ui, observable, observer, debug, pr, theme } from "aaa";
import { isPin } from "util/formValidations";

const notPin1 = "2345";
const notPin2 = "4444";

const a11yNotPin1 = "2 3 4 5";
const a11yNotPin2 = "4 4 4 4";

const ChoosePinComponent = (props: {
    name: string;
    defaultValue?: string;
}) => (
        <george.TextFieldFormsy
            name={props.name}
            required
            centered
            validations="isNumeric,isPin"
            inputValidations={isPin}
            validationError={ui.__("value.invalid")}
            inputMode="decimal"
            aria-label={ui.__("a11y.pin")}
            defaultValue={props.defaultValue}
        />
    );


export const ChoosePinEmbedded = observer((props: {
    name: string;
    defaultValue?: string;
}) => {
    return (
        <>
            <george.SectionTitle>
                {ui.__("shop.choosePin.title")}
            </george.SectionTitle>
            <p style={{ position: "absolute", opacity: 0 }}>
                {ui.__("shop.choosePin.info", { notPin1: a11yNotPin1, notPin2: a11yNotPin2 })}
            </p>
            <george.SectionSubtitleTop aria-hidden="true">
                {ui.__("shop.choosePin.info", { notPin1: notPin1, notPin2: notPin2 })}
            </george.SectionSubtitleTop>
            <ChoosePinComponent name={props.name} defaultValue={props.defaultValue} />
        </>
    );
});

export const ChoosePin = observer((props: {
    name: string;
    defaultValue?: string;
}) => {
    return (
        <george.Card>
            <george.CardSectionTitle title={ui.__("shop.choosePin.title")} />
            <george.CardSectionContent>
                <p style={{ position: "absolute", opacity: 0 }}>
                    {ui.__("shop.choosePin.info", { notPin1: a11yNotPin1, notPin2: a11yNotPin2 })}
                </p>
                <george.SectionSubtitleTop aria-hidden="true">
                    {ui.__("shop.choosePin.info", { notPin1: notPin1, notPin2: notPin2 })}
                </george.SectionSubtitleTop>
                <ChoosePinComponent name={props.name} defaultValue={props.defaultValue} />
            </george.CardSectionContent>
        </george.Card>
    );
});

export const ChoosePinResponsive = observer((props: {
    name: string;
    defaultValue?: string;
}) => {
    return (
        <>
            <george.SectionTitle style={{ marginTop: 0 }}>
                {ui.__("shop.choosePin.title")}
            </george.SectionTitle>
            <p style={{ position: "absolute", opacity: 0 }}>
                {ui.__("shop.choosePin.info", { notPin1: a11yNotPin1, notPin2: a11yNotPin2 })}
            </p>
            <george.SectionSubtitleTop aria-hidden="true">
                {ui.__("shop.choosePin.info", { notPin1: notPin1, notPin2: notPin2 })}
            </george.SectionSubtitleTop>
            <george.ResponsiveFormElement label={ui.__("common.pin")}>
                <ChoosePinComponent name={props.name} defaultValue={props.defaultValue} />
            </george.ResponsiveFormElement>
        </>
    );
});


// WEBPACK FOOTER //
// ./src/components/common/ChoosePin.tsx